import GET_ARTICLES from '../plugins/getArticles'

const [ w, d ] = [ window, document ]

const init = () => {

  //ticker
  $.when( w.load['block-ticker'] ).then( () => {
    let makeItem = item => $(`
      <a href="${item.href}" class="link">
        <span class="cat">${item.category.name}</span>
        <span class="date">${item.date}</span>
        <span class="subject">${item.title}</span>
      </a>
    `)[0]
    GET_ARTICLES( '.ticker__article[data-plugin="getArticles"]', { makeItem })
  })
  
  // works
  $.when( w.load['block-works'] ).then( () => {
    let makeItem = item => $(`
      <a href="${item.href}" class="works-item">
        <figure class="works-item__img">
          <div class="works-item__img-cover"><img src="${item.thumb}" alt="${item.title}" width=""></div>
        </figure>
        <div class="works-item__body">
          <span class="cat">${item.category.name}</span>
          <span class="date">${item.date}</span>
          ${item.is_new ? '<span class="new">NEW</span>': ''}
          <h4 class="subject">${item.title}</h4>
        </div>
      </a>
    `)[0]
    GET_ARTICLES('.block-works__list[data-plugin="getArticles"]',{ makeItem })
  })
  
  // news
  $.when( w.load['block-news'] ).then( () => {
    let makeItem = item => $(`
      <a href="${item.href}" class="link">
        <span class="date">${item.date}</span>
        <span class="cat">${item.category.name}</span>
        <span class="subject">
          ${item.title}
          ${item.is_new ? '<span class="new">NEW</span>': ''}
        </span>
        <svg class="icon" width="18" height="18"><use xlink:href="/asset/svg/sprite.symbol.svg#icon-arrow-right"></use></svg>
      </a>
    `)[0]
    GET_ARTICLES('.block-news__list[data-plugin="getArticles"]',{ makeItem })
  })

}


export default function HOME() {
  $(() => init() )
}